(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-bag"] && !Shopify.designMode) return;
  try {
    const btnList = document.querySelectorAll('.addToBag');

  const addToBag = (event) => {
    const btn = event.currentTarget;
    const variantId = btn.dataset.variantId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log('Produto adicionado ao carrinho:', data);
        window.location.href = '/checkout';
      })
      .catch((err) => {
        console.error('Erro ao adicionar produto ao carrinho:', err);
      });
  };

  btnList.forEach((btn) => {
    btn.addEventListener('click', addToBag);
  });
  } catch(e) { console.error(e); }
})();

})();
